import type { ImgHTMLAttributes } from "react"
import optimizedImages from "./optimizedImages.json"

type ImageInfo = { width: number; height: number; variants: { src: string; width: number }[] }
const images: Record<string, ImageInfo> = optimizedImages

export function HotelImage({ src = "", alt = "", sizes = "(min-width: 768px) 50vw, 100vw", loading = "lazy", ...props }: ImgHTMLAttributes<HTMLImageElement>) {
  const image = images[src]
  if (!image) return <img alt={alt} src={src} loading={loading} {...props} />
  const fallback = image.variants[Math.min(1, image.variants.length - 1)]
  return <img alt={alt} src={fallback.src} srcSet={image.variants.map(item => `${item.src} ${item.width}w`).join(", ")} sizes={sizes} width={image.width} height={image.height} loading={loading} decoding="async" {...props} />
}
